import buildNeeds from '../utils/buildNeeds';

import { Fetch, Params } from '../../shared/types';
import type { NeedResponse, ActionType, Action } from '../types';

type RequestData = {
  selected_api: string;
  type_of: ActionType;
  action: string;
  authentication_id?: number;
  params?: Params;
  readActions?: Action[];
};

type ResponseData = {
  needs: NeedResponse[];
};

/** Ignore all needs for which `computed` is `true`. */
export const filterNeeds = (needs: NeedResponse[]) =>
  needs.filter(({ computed }) => computed !== true);

export const getNeeds = async (
  fetch: Fetch,
  { readActions = [], ...body }: RequestData
) => {
  const { needs } = await fetch<ResponseData>(
    '/api/v4/implementations/needs/',
    { body }
  );
  return buildNeeds(
    filterNeeds(needs),
    body.selected_api,
    body.action,
    readActions
  );
};

export default getNeeds;
